import { useLocation, Navigate, Outlet } from "react-router-dom";
import SidebarContextProvider from "../../contexts/SidebarContext";
import { Footer, Header, Sidebar } from "../../component";
import { isLoggedIn } from "../../service";

const Layout = () => {
  return (
    <SidebarContextProvider>
    <main className="d-flex flex-nowrap">
      <Sidebar />
      <div className="w-100 overflow-auto main-wrapper min-vh-100 d-flex flex-column bg-color-primary">
        <Header />
        <section style={{ width: "100%", position: "relative", flex: 1, padding: "0 1rem"}}>
          <Outlet />
        </section>
      </div>
    </main>
  </SidebarContextProvider>
  )
};

export default Layout;
